import { AxiosError } from "axios";
import _ from "lodash";

import { IServerResponse } from "redux/actions/appActions";
import { tryParse } from "utils/expressions/conditionSolver";

/**
 * Get a catch block error message
 * https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript
 */
const getErrorMessage = (error: unknown) => {
  if (isAxiosError(error) && error.response?.data) {
    const rawData = error.response?.data;
    // if we fail to parse then its probably a string
    const data = tryParse(rawData) as Record<string, unknown> | string;

    if (!data && _.isString(rawData)) {
      return rawData;
    }

    if (_.isObject(data) && "message" in data) {
      return data.message as string;
    }

    if (isServerResponseError(error)) {
      return error.response.data.data.error.message;
    }
  }

  if (isErrorObject(error)) {
    return error.message;
  }

  return String(error);
};

function isAxiosError(error: unknown): error is AxiosError<any, any> {
  return (
    error instanceof AxiosError ||
    (typeof error === "object" && error !== null && "response" in error)
  );
}

function isErrorObject(error: unknown): error is Error {
  return (
    error instanceof Error ||
    (typeof error === "object" && error !== null && "message" in error)
  );
}

function isServerResponseError(error: unknown): error is IServerResponse<any> {
  return (
    (
      error as AxiosError<
        IServerResponse<{
          error: { message: string };
        }>["data"]
      >
    )?.response?.data?.data?.error?.message !== undefined
  );
}

export default getErrorMessage;
